import { Injectable } from "@angular/core";
import { AbstractControl, FormGroup, ValidatorFn } from "@angular/forms";

@Injectable({
  providedIn: "root"
})
export class CountryListValidator {
  public checkCountryListIfNecessary(): ValidatorFn {
    return (control: AbstractControl) => {
      const error: any = {};
      const formGroup = control as FormGroup;
      const { wireInternational, internationalCountry } = formGroup.value;
      const selectedCountryList = !Array.isArray(internationalCountry)
        ? (!!internationalCountry ? [internationalCountry] : [])
        : internationalCountry;

      if (wireInternational) {
        if (!selectedCountryList.length) {
          error["internationalCountry"] = true;
          return error;
        }
      }

      return null;
    }
  }
}
